import React, {useEffect, useRef, useState} from 'react';
import { withStyles } from "@mui/styles";
import QuestionNavigation from "./QuestionNavigation";

const styles = {
  root:{
    display: "flex",
    flexDirection: "column",
    gap: "0.5rem",
    padding: "0 !important",
  },
}

function MultipleChoiceSurvey(props) {
  const {
    mindfile,
    folderId,
    attemptId,
    surveyAttempt,
    answerSurvey,
    resetSurvey,
    QuestionPage,
    ResultsPage,
    classes,
    answerAllSurvey,
    filterName,
    openDataView,
    itemChangeCallback,
    isViewingShared
  } = props;

  const [questionIndex, setQuestionIndex] = useState(Math.min(surveyAttempt?.answer_count || 0, (surveyAttempt?.survey?.questions?.length || 0)) || 0);
  const answering = useRef(false);

  useEffect(() => {
    if(surveyAttempt.answer_count < questionIndex){
      setQuestionIndex(surveyAttempt.answer_count);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [surveyAttempt.answer_count]);

  const submitAnswer = (questionId, answerChoice, answerDate, comment, commentDate, callback) => {
    if(!answerSurvey){
      return false;
    }
    answering.current = true;
    const answer = [questionId || 0,
      {id: questionId || 0, values: answerChoice||[], answerDate: answerDate||new Date(Date.now()),
        ...(!!comment?.trim && comment.trim() !== "" ? {comment: comment, commentDate: commentDate} : {})}
    ]
    answerSurvey(answer, (data) => {
      try {
        callback(data)
      }finally {
        answering.current = false;
      }
    })
    return true;
  }

  const jumpToQuestion = (i) => {
    if(i >= surveyAttempt.survey?.question_count){
      setQuestionIndex(surveyAttempt.survey?.question_count);
    }else if(i <= 0){
      setQuestionIndex(0);
    }else{
      setQuestionIndex(Math.min(surveyAttempt.answer_count, i));
    }
  };

  return(
    <div className={classes.root}>
      <QuestionNavigation
        surveyAttempt={surveyAttempt}
        survey={surveyAttempt.survey}
        questionIndex={questionIndex}
        jumpToQuestion={jumpToQuestion}
        answering={answering}
      />
      {questionIndex >= surveyAttempt.survey.question_count ?
        <ResultsPage
          isViewingShared={isViewingShared}
          folderId={folderId}
          surveyAttempt={surveyAttempt}
          showGratitudeMeasurementTool={() => {}}
          resetGratitudeData={resetSurvey}
          loadingGratitudeScore={false}
          questionIndex={questionIndex}
          setQuestionIndex={setQuestionIndex}
          jumpToQuestion={jumpToQuestion}
          openDataView={openDataView}
          nextSurveyCallback={itemChangeCallback}
          filterName={filterName}
        />
        : <QuestionPage
          isViewingShared={isViewingShared}
          mindfile={mindfile}
          attemptId={attemptId}
          surveyAttempt={surveyAttempt}
          submitAnswer={submitAnswer}
          questionIndex={questionIndex}
          setQuestionIndex={setQuestionIndex}
          answerAllSurvey={answerAllSurvey}
        />
      }
    </div>
  );
}

export default withStyles(styles)(MultipleChoiceSurvey);
